module.exports = __webpack_public_path__ + "static/media/icon_user_low.4fa38a20.png";